export enum HeaderActionType {
  ToggleSearch = 'ToggleSearch',
}

export type Action = { type: HeaderActionType.ToggleSearch; isOpen: boolean };

export type State = {
  isSearchOpen: boolean;
};
